import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalData } from '../../../../../../selectors/buyPackageModal';
import { capitalize } from '../../../../../../utils/string';
import { Detail } from '../Detail';

export const CategoriesContainer = () => {
  const data = useSelector(selectBuyPackageModalData);

  const { categoriesView } = data;

  return <Detail title="Категории">{capitalize(categoriesView)}</Detail>;
};
